// Full mock implementation of the api surface. This is the source of
// truth for what the api can do — every method on `Api` is fully
// realised here with realistic data and timings. The real http provider
// (lands at ../http/) implements the same shape; nothing outside this
// directory (other than ../client.ts) is allowed to know which one is
// active.
//
// Add new entities by dropping a sibling file (./products.ts,
// ./orders.ts, …) that exports the namespace as `Api["<entity>"]`, then
// register it below. Keep one file per entity — composition stays
// readable as the surface grows.
import type { Api } from "../types";
import { analytics } from "./analytics";
import { auth } from "./auth";
import { applications_api } from "./applications";
import { applicationCrm } from "./application-crm";
import { catalogImport } from "./catalog-import";
import { carts } from "./carts";
import { categories } from "./categories";
import { compliance } from "./compliance";
import { commissions } from "./commissions";
import { dashboard } from "./dashboard";
import { feed } from "./feed";
import { finances } from "./finances";
import { geo } from "./geo";
import { ideasApi } from "./ideas";
import { inspirationFeed } from "./inspiration-feed";
import { inspirationIdeas } from "./inspiration-ideas";
import { orders } from "./orders";
import { notificationCampaigns, notifications } from "./notifications";
import { platformRoles } from "./platform-roles";
import { partners, promos } from "./promos";
import { products } from "./products";
import { reports } from "./reports";
import { returns } from "./returns";
import { sellers } from "./sellers";
import { settings } from "./settings";
import { deliveryCarriers } from "./delivery-carriers";
import { sms } from "./sms";
import { integrations } from "./integrations";
import { email } from "./email";
import { storefronts } from "./storefronts";
import { audit } from "./audit";
import { support } from "./support";
import { users } from "./users";
import { ugc } from "./ugc";
import { mockPromoCampaigns } from "../promo-campaigns";

export const mock: Api = {
	promoCampaigns: mockPromoCampaigns,
	ugc,
	auth,
	products,
	users,
	platformRoles,
	notifications,
	notificationCampaigns,
	categories,
	compliance,
	inspirationFeed,
	inspirationIdeas,
	feed,
	ideas: ideasApi,
	orders,
	returns,
	carts,
	storefronts,
	sellers,
	settings,
	deliveryCarriers,
	sms,
	integrations,
	email,
	geo,
	analytics,
	dashboard,
	finances,
	commissions,
	promos,
	partners,
	applications: applications_api,
	applicationCrm,
	catalogImport,
	reports,
	support,
	audit,
};
